import { network } from 'services/network';

import { Payload } from 'api/endPoints/getPivotTable';

export const extractPivotTableToCsv = (params) => {
    return network.post('api/bo/extractPivotTableToCsv', params.payload).then((response) => {
        const blob = new Blob([response.data], {
            type: 'text/plain',
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = `${params.fileName}.csv`;
        a.click();

        return true;
    });
};

export interface QueryParams {
    payload: Payload;
    fileName: string;
}
